import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Tv, Radio, PlayCircle, ArrowLeft } from "lucide-react";
import GlobalAppHeader from "@/components/shared/GlobalAppHeader";
import GlobalAppFooter from "@/components/shared/GlobalAppFooter";

function embed(url) {
  const m = (url || "").match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]+)/);
  return m ? `https://www.youtube.com/embed/${m[1]}` : null;
}

export default function ChannelPublic() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [active, setActive] = useState(null);
  useEffect(() => { api.get(`/tv/creators/${id}`).then(r => setData(r.data)).catch(() => {}); }, [id]);
  if (!data) return <div className="min-h-screen grid place-items-center text-white bg-[#0F1020] mono">Loading…</div>;
  const { channel, content, live } = data;
  return (
    <div className="min-h-screen bg-[#0F1020] text-white max-w-full overflow-x-hidden">
      <GlobalAppHeader />
      <div className="h-44 bg-gradient-to-r from-indigo-900 to-purple-900 border-b-2 border-white/20 flex items-end">
        <div className="max-w-5xl mx-auto w-full px-6 pb-4 flex items-center gap-3">
          <div className="w-16 h-16 bg-white/10 border border-white/20 rounded grid place-items-center"><Tv size={28} /></div>
          <div><h1 className="display text-3xl font-black">{channel.display_name}</h1>
            <div className="text-sm opacity-70">{channel.organization} · {(channel.boards || []).join(", ")}</div></div>
        </div>
      </div>
      <main className="max-w-5xl mx-auto p-6 space-y-6">
        <Link to="/tv" className="nb-btn nb-btn-ghost text-xs"><ArrowLeft size={14} /> Back to Ponderr TV</Link>
        {live.length > 0 && <section>
          <div className="flex items-center gap-2 mb-2"><Radio size={16} className="text-red-400" /><h2 className="display text-lg font-bold">Broadcasts</h2></div>
          <div className="flex gap-3 overflow-x-auto pb-2">
            {live.map(s => <a key={s.session_id} href={s.meeting_url || "#"} target="_blank" rel="noreferrer" className="min-w-[220px] rounded-lg p-3 bg-white/5 border border-white/10">
              <div className="text-xs mono opacity-60">{s.platform}</div><div className="font-bold text-sm">{s.title}</div></a>)}
          </div>
        </section>}
        <section data-testid="channel-playlist">
          <h2 className="display text-lg font-bold mb-2">Playlist</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {content.map(c => <button key={c.content_id} onClick={() => setActive(c)} className="text-left rounded-xl overflow-hidden bg-white/5 border border-white/10 hover:border-white/40">
              <div className="h-28 bg-black/40 grid place-items-center">{c.thumbnail_url ? <img src={c.thumbnail_url} alt={c.title} className="w-full h-full object-cover" /> : <PlayCircle size={36} className="opacity-50" />}</div>
              <div className="p-3"><div className="font-bold text-sm">{c.title}</div><div className="text-xs opacity-60">{c.board} {c.grade} · {c.subject}</div></div>
            </button>)}
            {content.length === 0 && <div className="col-span-full text-center py-8 opacity-60">No published content yet.</div>}
          </div>
        </section>
      </main>
      {active && <div className="fixed inset-0 z-50 grid place-items-center bg-black/80 p-4" onClick={() => setActive(null)}>
        <div className="max-w-3xl w-full space-y-2" onClick={e => e.stopPropagation()}>
          <div className="aspect-video bg-black rounded-xl overflow-hidden border-2 border-white/20">
            {embed(active.external_url) ? <iframe title={active.title} src={embed(active.external_url)} className="w-full h-full" allowFullScreen /> : active.media_url ? <video src={active.media_url} controls className="w-full h-full" /> : <div className="grid place-items-center h-full opacity-60">No source</div>}
          </div>
          <div className="flex justify-between items-center"><div className="font-bold">{active.title}</div><button className="nb-btn nb-btn-danger" onClick={() => setActive(null)}>Close</button></div>
        </div>
      </div>}
      <GlobalAppFooter />
    </div>
  );
}
